export default {
  INSERT_INTO_ALL: "INSERT_INTO_ALL_INVOICING_IMD_INVOICING",
  ADD_TO_IN_PROGRESS: "ADD_TO_IN_PROGRESS_INVOICING_IMD_INVOICING",
  REMOVE_FROM_IN_PROGRESS: "REMOVE_FROM_IN_PROGRESS_INVOICING_IMD_INVOICING",
  INSERT_INTO_FORMS: "INSERT_INTO_FORMS_INVOICING_IMD_INVOICING",
  DESTROY_FORM: "DESTROY_FORM_INVOICING_IMD_INVOICING",
  SET_FORM_ERROR: "SET_FORM_ERROR_INVOICING_IMD_INVOICING",
  UPDATE_FORM_INSTANCE: "UPDATE_FORM_INSTANCE_INVOICING_IMD_INVOICING",
  INSERT_INTO_PAGINATION: "INSERT_INTO_PAGINATION_INVOICING_IMD_INVOICING",
  INSERT_INTO_FILTERED: "INSERT_INTO_FILTERED_INVOICING_IMD_INVOICING",
  RESET_STATE: "RESET_STATE_INVOICING_IMD_INVOICING",
  SET_ASK_DELETE_DATA: "SET_ASK_DELETE_DATA_INVOICING_IMD_INVOICING",
  REMOVE_OBJECT: "REMOVE_OBJECT_INDUSTRIAL_INVOICING_IMD_INVOICING",
  CLEAR_FETCHED: "CLEAR_FETCHED_INVOICING_IMD_INVOICING",

  LIST_URL: "/accounting/configs/imdinvoiceconfig/list/",
  POST_URL: "/accounting/configs/imdinvoiceconfig/",
  PATCH_URL: "/accounting/configs/imdinvoiceconfig/",
  GET_URL: "/accounting/configs/imdinvoiceconfig/",

  STORE_NAME: "invoicingIMD",
};
